// extracted by mini-css-extract-plugin
export default {"list":"insight-list_list__jwua4","empty":"insight-list_empty__KgNjg"};